export const APP_NAME = (import.meta.env.VITE_APP_BRAND as string) || "Lumo";
export const APP_TAGLINE =
  (import.meta.env.VITE_APP_TAGLINE as string) || "Organize suas finanças com simplicidade";
export const COPYRIGHT = `© ${new Date().getFullYear()} ${APP_NAME}`;
